import { lazy } from 'react';

const AddSignatureModal = lazy(
  () => import('modules/EFill/modals/AddSignatureModal/AddSignatureModal'),
);

const AddStepModal = lazy(
  () => import('modules/EFill/modals/AddStepModal/AddStepModal'),
);

const DeleteTemplateModal = lazy(
  () => import('modules/EFill/modals/DeleteTemplateModal/DeleteTemplateModal'),
);

const EditTemplateModal = lazy(
  () => import('modules/EFill/modals/EditTemplateModal/EditTemplateModal'),
);

const InstructionsModal = lazy(
  () => import('modules/EFill/modals/InstructionsModal/InstructionsModal'),
);

const TemplateLockedModal = lazy(
  () => import('modules/EFill/modals/TemplateLockedModal/TemplateLockedModal'),
);

export default {
  EFILL_ADD_SIGNATURE_MODAL: AddSignatureModal,
  EFILL_ADD_STEP_MODAL: AddStepModal,
  EFILL_DELETE_TEMPLATE_MODAL: DeleteTemplateModal,
  EFILL_EDIT_TEMPLATE_MODAL: EditTemplateModal,
  EFILL_INSTRUCTIONS_MODAL: InstructionsModal,
  EFILL_TEMPLATE_LOCKED_MODAL: TemplateLockedModal,
};
